import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import { Link } from 'react-router-dom';

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    totalActivities: 0,
    totalBookings: 0,
    pendingBookings: 0,
    confirmedBookings: 0,
    totalRevenue: 0
  });
  const [pendingBookings, setPendingBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const { token } = useAuth();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [activitiesRes, bookingsRes, pendingRes] = await Promise.all([
        axios.get('/api/activities'),
        axios.get('/api/bookings/admin/all', {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get('/api/bookings/admin/pending', {
          headers: { Authorization: `Bearer ${token}` }
        })
      ]);

      const bookings = bookingsRes.data;
      const confirmedBookings = bookings.filter(b => b.status === 'confirmed');
      const totalRevenue = confirmedBookings.reduce((sum, b) => sum + b.paymentAmount, 0);

      setStats({
        totalActivities: activitiesRes.data.length,
        totalBookings: bookings.length,
        pendingBookings: pendingRes.data.length,
        confirmedBookings: confirmedBookings.length,
        totalRevenue
      });

      setPendingBookings(pendingRes.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  const handleConfirm = async (bookingId) => {
    try {
      await axios.patch(`/api/bookings/${bookingId}/confirm`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert('Payment confirmed successfully!');
      fetchData();
    } catch (error) {
      alert('Error confirming payment');
    }
  };

  const handleReject = async (bookingId) => {
    if (window.confirm('Are you sure you want to reject this booking?')) {
      try {
        await axios.patch(`/api/bookings/${bookingId}/reject`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
        alert('Booking rejected');
        fetchData();
      } catch (error) {
        alert('Error rejecting booking');
      }
    }
  };

  const formatTime = (date) => {
    const now = new Date();
    const bookingDate = new Date(date);
    const diffMs = now - bookingDate;
    const diffMins = Math.floor(diffMs / 60000);
    
    if (diffMins < 60) return `${diffMins} minutes ago`;
    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours} hours ago`;
    return bookingDate.toLocaleDateString();
  };

  if (loading) return <div style={styles.loading}>Loading...</div>;

  return (
    <div style={styles.container}>
      <h1 style={styles.pageTitle}>Admin Dashboard</h1>
{/* Stats Cards */}
<div style={styles.statsGrid}>
  <div style={styles.statCard}>
    <div style={styles.statIcon}>Activities</div>
    <div style={styles.statValue}>{stats.totalActivities}</div>
    <div style={styles.statLabel}>Total Activities</div>
  </div>

  <div style={styles.statCard}>
    <div style={styles.statIcon}>Bookings</div>
    <div style={styles.statValue}>{stats.totalBookings}</div>
    <div style={styles.statLabel}>Total Bookings</div>
  </div>

  <div style={styles.statCard}>
    <div style={styles.statIcon}>Pending</div>
    <div style={styles.statValue}>{stats.pendingBookings}</div>
    <div style={styles.statLabel}>Pending Payments</div>
  </div>

  <div style={styles.statCard}>
    <div style={styles.statIcon}>Confirmed</div>
    <div style={styles.statValue}>{stats.confirmedBookings}</div>
    <div style={styles.statLabel}>Confirmed Bookings</div>
  </div>
</div>

      {/* Pending Payments Section */}
      {pendingBookings.length > 0 && (
        <div style={styles.pendingSection}>
          <h2 style={styles.sectionTitle}>
             Pending Payment Confirmations ({pendingBookings.length})
          </h2>
          <p style={styles.sectionSubtitle}>Review M-Pesa messages and confirm payments</p>

          <div style={styles.bookingsGrid}>
            {pendingBookings.map(booking => (
              <div key={booking._id} style={styles.bookingCard}>
                <div style={styles.bookingHeader}>
                  <h3 style={styles.bookingName}>{booking.userName}</h3>
                  <span style={styles.timeAgo}>{formatTime(booking.createdAt)}</span>
                </div>

                <div style={styles.bookingDetails}>
                  <div style={styles.detailRow}>
                    <span style={styles.detailIcon}></span>
                    <span style={styles.detailText}>{booking.userPhone}</span>
                  </div>
                  <div style={styles.detailRow}>
                    <span style={styles.detailIcon}></span>
                    <span style={styles.detailText}>M-Pesa Name: <strong>{booking.mpesaName}</strong></span>
                  </div>
                  <div style={styles.detailRow}>
                    <span style={styles.detailIcon}></span>
                    <span style={styles.detailText}>{booking.activityId?.name} - {booking.activityId?.day} {booking.activityId?.time}</span>
                  </div>
                  <div style={styles.detailRow}>
                    <span style={styles.detailIcon}></span>
                    <span style={{...styles.detailText, color: '#1a5632', fontWeight: 700, fontSize: '1.1rem'}}>
                      KES {booking.paymentAmount}
                    </span>
                  </div>
                  {booking.notes && (
                    <div style={styles.notesBox}>
                      <strong>Notes:</strong> {booking.notes}
                    </div>
                  )}
                </div>

                <div style={styles.verificationBox}>
                  <p style={styles.verificationText}>
                    ✓ Check M-Pesa message for payment from: <strong>{booking.mpesaName}</strong>
                  </p>
                </div>

                <div style={styles.actionButtons}>
                  <button 
                    onClick={() => handleConfirm(booking._id)}
                    style={styles.confirmBtn}
                  >
                     Confirm Payment
                  </button>
                  <button 
                    onClick={() => handleReject(booking._id)}
                    style={styles.rejectBtn}
                  >
                     Reject
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Quick Links */}
      <Link to="/admin/menu" style={styles.linkCard}>
  <div style={styles.linkIcon}></div>
  <div style={styles.linkTitle}>Manage Menu</div>
  <div style={styles.linkDesc}>Edit prices & availability</div>
</Link>
      <div style={styles.quickLinks}>
        <h2 style={styles.sectionTitle}>Quick Actions</h2>
        <div style={styles.linksGrid}>
          <Link to="/admin/activities" style={styles.linkCard}>
            <div style={styles.linkIcon}></div>
            <div style={styles.linkTitle}>Manage Activities</div>
            <div style={styles.linkDesc}>Edit capacity, prices & details</div>
          </Link>

          <Link to="/admin/bookings" style={styles.linkCard}>
            <div style={styles.linkIcon}></div>
            <div style={styles.linkTitle}>All Bookings</div>
            <div style={styles.linkDesc}>View complete booking history</div>
          </Link>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: { maxWidth: '1400px', margin: '0 auto', padding: '2rem', background: '#fafafa', minHeight: '100vh' },
  loading: { textAlign: 'center', padding: '4rem', fontSize: '1.2rem' },
  pageTitle: { fontSize: '2.5rem', marginBottom: '2rem', color: '#1a5632', fontFamily: 'Playfair Display, serif' },
  
  // Stats Cards
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem', marginBottom: '3rem' },
  statCard: { background: 'white', padding: '2rem', borderRadius: '15px', textAlign: 'center', boxShadow: '0 2px 10px rgba(0,0,0,0.05)', border: '2px solid #f0f0f0' },
  statIcon: { fontSize: '2.5rem', marginBottom: '0.5rem' },
  statValue: { fontSize: '2.5rem', fontWeight: 700, color: '#1a5632', marginBottom: '0.5rem' },
  statLabel: { color: '#5A5A5A', fontSize: '0.95rem', fontWeight: 500 },
  
  // Pending Section
  pendingSection: { background: 'white', padding: '2rem', borderRadius: '15px', marginBottom: '3rem', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' },
  sectionTitle: { fontSize: '1.8rem', color: '#2C2C2C', marginBottom: '0.5rem', fontFamily: 'Playfair Display, serif' },
  sectionSubtitle: { color: '#888', marginBottom: '2rem', fontSize: '1rem' },
  
  // Booking Cards
  bookingsGrid: { display: 'grid', gap: '1.5rem' },
  bookingCard: { background: '#fafafa', padding: '1.5rem', borderRadius: '12px', border: '2px solid #FFA8B9' },
  bookingHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', paddingBottom: '1rem', borderBottom: '2px solid #e0e0e0' },
  bookingName: { fontSize: '1.3rem', color: '#2C2C2C', fontWeight: 700 },
  timeAgo: { background: '#fff3cd', color: '#856404', padding: '0.25rem 0.75rem', borderRadius: '15px', fontSize: '0.85rem', fontWeight: 600 },
  
  bookingDetails: { marginBottom: '1rem' },
  detailRow: { display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.5rem 0' },
  detailIcon: { fontSize: '1.2rem' },
  detailText: { color: '#2C2C2C', fontSize: '1rem' },
  notesBox: { background: 'white', padding: '0.75rem', borderRadius: '8px', marginTop: '0.75rem', fontSize: '0.95rem', color: '#5A5A5A' },
  
  verificationBox: { background: '#e8f5e9', padding: '1rem', borderRadius: '8px', marginBottom: '1rem', border: '2px solid #7AB845' },
  verificationText: { color: '#1a5632', fontSize: '0.95rem', margin: 0 },
  
  actionButtons: { display: 'flex', gap: '1rem' },
  confirmBtn: { flex: 1, background: '#7AB845', color: 'white', padding: '1rem', fontSize: '1rem', fontWeight: 700, border: 'none', borderRadius: '10px', cursor: 'pointer', transition: 'all 0.3s' },
  rejectBtn: { flex: 1, background: '#F44336', color: 'white', padding: '1rem', fontSize: '1rem', fontWeight: 700, border: 'none', borderRadius: '10px', cursor: 'pointer', transition: 'all 0.3s' },
  
  // Quick Links
  quickLinks: { background: 'white', padding: '2rem', borderRadius: '15px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' },
  linksGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem', marginTop: '1.5rem' },
  linkCard: { background: '#fafafa', padding: '2rem', borderRadius: '12px', textAlign: 'center', textDecoration: 'none', border: '2px solid #e0e0e0', transition: 'all 0.3s' },
  linkIcon: { fontSize: '3rem', marginBottom: '1rem' },
  linkTitle: { fontSize: '1.3rem', color: '#1a5632', fontWeight: 700, marginBottom: '0.5rem' },
  linkDesc: { color: '#5A5A5A', fontSize: '0.95rem' }
};

export default AdminDashboard;